import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { User } from '../../../../core/interfaces/user';
import { AuthApiService } from '../../../../core/services/auth-api.service';
import { InputSelectComponent } from '../../../../shared/components/input-select/input-select.component';
import { InputTextComponent } from '../../../../shared/components/input-text/input-text.component';
import { MultiSelectInputComponent } from '../../../../shared/components/multi-select-input/multi-select-input.component';
import { BlockUIModule } from 'primeng/blockui';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { AccountApiService } from '../../../../core/services/account-api.service';
import { SelectInput } from '../../../../shared/interfaces/select-input';
import { OrganizationApiService } from '../../../../core/services/organization-api.service';
import { requiredIfValidator } from '../../../../shared/validators/requiredIf-present.validator';

@Component({
  selector: 'app-new-user',
  imports: [ButtonModule, 
            TableModule, 
            DialogModule, 
            InputTextComponent, 
            InputSelectComponent,
            ToastModule, 
            MultiSelectModule, 
            ReactiveFormsModule, 
            MultiSelectInputComponent,
            BlockUIModule,
            ProgressSpinnerModule],
  templateUrl: './new-user.component.html',
  styleUrl: './new-user.component.scss'
})
export class NewUserComponent {

  @Input() visible!: boolean;
  accountOptions: SelectInput[] = [];
  @Output() closeDialog = new EventEmitter();
  blockedDocument: boolean = false;
  organizationOptions: SelectInput[] = [];
  accountId!: string;

  roles = [  {label: 'User', code: 'ROLE_USER'},
             {label: 'Admin', code: 'ROLE_ADMIN'}]

  statusOptions = [  {label: 'Yes', code: true},
             {label: 'No', code: false}]

  userForm = new FormGroup({
                   username: new FormControl('', [Validators.required, Validators.maxLength(50)]),
                   email: new FormControl('', [Validators.required, Validators.email, Validators.maxLength(50)]),
                   organizationID: new FormControl('', ),
                   organizationTitle: new FormControl('',Validators.maxLength(50)),
                   accountID: new FormControl('', Validators.required,),
                   roles: new FormControl([], Validators.required,),
                   active: new FormControl(true, Validators.required,)},
                  {
                    validators: [requiredIfValidator('organizationTitle', 'organizationID', 'Organization'),]
                   }
   );

   constructor(private messageService: MessageService, private authService: AuthApiService,  
    private accountApi: AccountApiService, private organizationApi: OrganizationApiService) {
      this.userForm.get('organizationTitle')!.valueChanges.subscribe(() => {
        this.userForm.get('organizationID')!.updateValueAndValidity();
      });
   }

   loadData() {
    this.loadAccounts()
    this.loadOrganizations()     
    this.userForm = new FormGroup({
                   username: new FormControl('', [Validators.required, Validators.maxLength(50)]),
                   email: new FormControl('', [Validators.required, Validators.email, Validators.maxLength(50)]),
                   organizationID: new FormControl('', ),
                   organizationTitle: new FormControl('',Validators.maxLength(50)),
                   accountID: new FormControl('', Validators.required,),
                   roles: new FormControl([], Validators.required,),
                   active: new FormControl(true, Validators.required,),},
                                    {
                    validators: [requiredIfValidator('organizationTitle', 'organizationID', 'Organization'),]
                   });
    this.accountId = localStorage.getItem("accountId") || "";
    this.userForm.controls.accountID.setValue(this.accountId);
    this.userForm.get('organizationID')!.valueChanges.subscribe(() => {
      this.userForm.get('organizationTitle')!.updateValueAndValidity();
    });
   }
             
  save() {

    if (this.userForm.valid) {
     const user: User = this.userForm.value as User
     this.blockedDocument = true;
     this.authService.createUser(user).subscribe({
        next: (data) =>{
          this.blockedDocument = false;
          this.messageService.add({ severity: 'info', summary: 'Success', detail: 'User was succesfully created.' })
          this.close()
        } ,
        error: (err) => {
          this.blockedDocument = false;

          let errorMessage = ""
          if(err.error.message) {
              errorMessage += "Reason: " + err.error.message;
          } else {
              errorMessage =  "A problem occurred during the user creation.";
          }
          this.messageService.add({ severity: 'error', summary: 'Error', 
                    detail: errorMessage, life: 5000 })          

        }
     })
    } else {
        this.userForm.markAllAsTouched();
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Please, verify the required fields.', life: 5000 })

    }

  }

    close() {
      this.closeDialog.emit("")
  }

  loadAccounts() {
    
    //if role_sys_admin load all accounts, else loads only user account
    if (this.isSysAdmin) {
      this.accountOptions = [    {
        "code": "",
        "label": "Select Account"
       },]
      this.accountApi.getAccounts().subscribe({
        next: (data) => {
          for(let item of data) {
            this.accountOptions.push({label: item.name, code: item.id})     
          }
        }, error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: "It wasn't possible to load the accounts.", life: 5000 })
        }
        
      })

    }

  }

  loadOrganizations() {

      this.organizationOptions = [    {
        "code": "",
        "label": "Select Organization"
       },]
      this.organizationApi.getOrganization().subscribe({
        next: (data) => {
          for(let item of data) {
            this.organizationOptions.push({label: item.name, code: item.id})         
          }
        }, error: (err) => {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: "It wasn't possible to load the accounts.", life: 5000 })
        }
        
      })
    

  }

  get isSysAdmin() {
      const userRoles = localStorage.getItem('roles')?.split(',');
      return userRoles?.includes("ROLE_SYS_ADMIN");
  }
}
